import React from 'react';
import Select from 'react-select';
import './LanguageSelector.css';

const LanguageSelector = ({ currentLanguage, onLanguageChange }) => {
  const languages = [
    { value: 'fr', label: '🇫🇷 Français' },
    { value: 'en', label: '🇬🇧 English' },
    { value: 'de', label: '🇩🇪 Deutsch' },
    { value: 'it', label: '🇮🇹 Italiano' }
  ];

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      minHeight: '40px',
      border: '2px solid #e5e7eb',
      borderRadius: '8px',
      boxShadow: 'none',
      '&:hover': {
        borderColor: '#667eea',
      },
      borderColor: state.isFocused ? '#667eea' : '#e5e7eb',
    }),
    valueContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    input: (provided) => ({
      ...provided,
      margin: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided) => ({
      ...provided,
      padding: '0 8px',
    }),
    menu: (provided) => ({
      ...provided,
      borderRadius: '8px',
      boxShadow: '0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
      border: '1px solid #e5e7eb',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected 
        ? '#667eea' 
        : state.isFocused 
          ? '#f3f4f6' 
          : 'white',
      color: state.isSelected ? 'white' : '#374151',
      padding: '12px 16px',
      fontSize: '14px',
      fontWeight: '500',
    }),
    singleValue: (provided) => ({
      ...provided,
      color: '#374151',
      fontSize: '14px',
      fontWeight: '500',
    }),
  };

  const selectedLanguage = languages.find(lang => lang.value === currentLanguage);

  return (
    <div className="language-selector">
      <Select
        value={selectedLanguage}
        onChange={(option) => onLanguageChange(option.value)}
        options={languages}
        styles={customStyles}
        isSearchable={false}
        className="language-select"
        classNamePrefix="language-select"
      />
    </div>
  );
};

export default LanguageSelector;
